var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"get-help"},[_c('img',{staticClass:"gethelp_image",attrs:{"alt":"gethelp.image"}}),_c('p',{staticClass:"is-size-7-mobile is-size-5-desktop has-text-primary specific-sentance ml-1",staticStyle:{"letter-spacing":"0.6px"}},[_vm._v(" Get Help ")])])
}]

export { render, staticRenderFns }